export default __webpack_public_path__ + "static/1741-7b42e19b894f87896346ddce459de8b4.gif";